import { useEffect } from 'react';
import { SwitchToLargeModeButton } from '@frontend/analytics-shared';
import { useTranslation } from '@frontend/i18n';
import { useIsSmallMode } from '@frontend/shared';
import { ButtonBar, Modal, useModalControl } from '@frontend/design-system';

interface MultiLocationLargeModeOnlyFeatureProps {
  locationCount?: number;
}

export const MultiLocationLargeModeOnlyFeature = ({ locationCount = 0 }: MultiLocationLargeModeOnlyFeatureProps) => {
  const { t } = useTranslation('analytics');
  const { closeModal, modalProps, openModal } = useModalControl();
  const { isSmallMode } = useIsSmallMode();

  useEffect(() => {
    if (isSmallMode && locationCount > 1) {
      openModal();
    }
  }, [isSmallMode, locationCount, openModal]);

  if (!isSmallMode) {
    return null;
  }

  return (
    <Modal {...modalProps} disableCloseOnEscape disableCloseOnOverlayClick>
      <Modal.Header onClose={closeModal}>{t('Multi-location Unsupported')}</Modal.Header>
      <Modal.Body>
        {t(
          "The multi-location feature isn't supported in small screen mode. To explore trends across locations, please check the dashboard on a larger device."
        )}
      </Modal.Body>
      <Modal.Footer>
        <ButtonBar>
          <SwitchToLargeModeButton />
        </ButtonBar>
      </Modal.Footer>
    </Modal>
  );
};
